if (!customElements.get('header-ancillary')) {
  customElements.define(
    'header-ancillary',
    class HeaderAncillary extends HTMLElement {
      constructor() {
        super();

        this.menu = this.querySelector('.header-ancillary__item--menu');

        this.menu?.addEventListener('click', this.onClickHandler.bind(this));
        document.addEventListener('keyup', this.handleKeyup.bind(this));
      }

      onClickHandler() {
        this.menu?.getAttribute('aria-pressed') === 'false' ? this.handleOpen() : this.handleClose();
      }

      handleClose() {
        this.menu?.setAttribute('aria-pressed', 'false');
      }

      handleOpen() {
        this.menu?.setAttribute('aria-pressed', 'true');
      }

      handleKeyup(e) {
        switch (e.key) {
          case 'Escape':
            this.handleClose();
          default:
            break;
        }
      }
    },
  );
}
